import * as R from "ramda";

export const getSearchType = R.compose(
  R.last,
  R.reject(R.isEmpty),
  R.split("/"),
);
export const toggleFacet = (id, value, state) => {
  const stateArr = R.compose(R.map((n) => String(n)))(
    R.unnest([state?.[id] ? state[id] : []]),
  );
  return { [id]: R.symmetricDifference([String(value)], stateArr) };
};

export const getInjectable = (id) => {
  const markup = document.querySelector(id)?.innerHTML;
  document.querySelector(id)?.remove();
  return markup;
};

export const scrollToResults = (el) => {
  setTimeout(() => {
    const results = document.querySelector(el);
    results.scrollIntoView({
      behavior: "smooth",
      block: "start",
      inline: "nearest",
    });

    results.focus({ preventScroll: true });
  }, 1000);
};

const parseObj = R.compose((obj) =>
  R.map(
    R.applySpec({
      [`${obj.id}`]: R.prop("id"),
      name: R.prop("name"),
    }),
  )(R.prop("values", obj)),
);

const createItem = R.applySpec({
  label: (d, v) => R.compose(R.join(" "), R.pluck("name"))([d, v]),
  values: R.compose(R.dissoc("name"), R.dissoc("selected"), R.merge),
});

//returns array for rate board modal
export const parseOptions = (obj1, obj2) =>
  parseObj(obj1).flatMap((d) => parseObj(obj2).map((v) => createItem(d, v)));

export const getDate = (str) => {
  const d = new Date(str.replace(/-/g, "/"));
  return d.toLocaleDateString();
};

/**
 * metaParser should return an array of objects
 *
 * [
 *   {
 *     field_id: "field_content_type",
 *     label: "Content Type",
 *     url_alias: "content_type",
 *     values: [
 *       {
 *         raw_value: "411",
 *         url: "https:...",
 *         values: {
 *           value: "Press Release",
 *           count: 11,
 *         },
 *       },
 *     ],
 *   },
 * ]
 *
 */
export const metaParser = (data) => {
  /* return empty if undefined */
  if (!data?.facets_metadata || !data?.facets) return [];

  const { facets_metadata, facets } = data;
  const meta = R.values(facets_metadata);

  // Facets are arrays nested in an array; flatten this
  const collapsedFacets = facets.map((facet) => {
    return facet[0];
  });

  // Merge the objects in this array into a single object
  const facetsObj = Object.assign({}, ...collapsedFacets);

  // Add values from the metadata into our object
  const parsedFacets = R.map((i) =>
    R.assoc("values", R.prop(i.field_id)(facetsObj), i),
  )(meta);

  return parsedFacets;
};
